import {put, takeLatest, call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService";
import {
    DELETE_IMAGE,
    DELETE_IMAGE_SUCCESS,
    DELETE_IMAGE_ERROR
}
    from "../../actions/image";

function* deleteImageSaga(action) {
    try {
        yield call(imageService.DeleteImage, action.payload)
        yield put({
            type: DELETE_IMAGE_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_IMAGE_ERROR,error: error.data
        });
    }
}


export function* deleteImageSagaWatcher() {
    yield takeLatest(DELETE_IMAGE, deleteImageSaga);
}